import team3 from "@/assets/img/team/3.jpg";
import Avatar from "@/components/atoms/Avatar";
import AvailabilityModal from "@/components/molecules/modals/availability/AvailabilityModal";
import { isStrictAdmin } from "@/helpers/UserHelpers";
import { useLogoutMutation } from "@/services/auth";
import { selectCurrentUser } from "@/services/slices/authSlice";
import { useUpdateCursorsEnabledMutation } from "@/services/users";
import { faArrowPointer } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ElementRef, FC, useRef } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ProfileDropdown: FC = () => {
  const user = useSelector(selectCurrentUser);
  const navigation = useNavigate();
  const AvailabilityModalRef =
    useRef<ElementRef<typeof AvailabilityModal>>(null);
  const [logoutAsync] = useLogoutMutation();
  const [updateCursorsEnabled, { isLoading: isTogglingCursors }] =
    useUpdateCursorsEnabledMutation();
  const [_, __, removeCookie] = useCookies(["te_co"]);

  const isAdmin = isStrictAdmin(user);
  const cursorsEnabled = user?.cursorsEnabled !== false;

  const onToggleCursors = () => {
    updateCursorsEnabled(!cursorsEnabled);
  };

  const handleLogout = () => {
    toast.promise(logoutAsync().unwrap(), {
      pending: "Authentification en cours...",
      success: {
        render() {
          removeCookie("te_co", { path: "/" });
          navigation("/auth/login");
          return "Aurevoir 👋";
        },
      },
      error: {
        render() {
          return "Une erreur est survenue lors de la deconnexion";
        },
      },
    });
  };

  return (
    <>
      <Dropdown navbar={true} as="li">
        <Dropdown.Toggle
          bsPrefix="toggle"
          as={"div"}
          className="pe-0 ps-2 nav-link cursor-pointer"
        >
          <Avatar src={user.avatar ? user.avatar.link : team3} alt="Logo" />
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
          <div className="bg-white rounded-2 py-2 dark__bg-1000">
            <Dropdown.Item as={Link} to={`/users/${user!.id}`}>
              Profil &amp; Compte
            </Dropdown.Item>
            <Dropdown.Item
              as="button"
              onClick={() => AvailabilityModalRef.current?.showOrHiddenModal()}
            >
              Mes disponibilités
            </Dropdown.Item>
            {isAdmin && (
              <>
                <Dropdown.Divider />
                {/* Ligne de préférence : div (pas Dropdown.Item) pour que basculer
                  l'interrupteur ne ferme pas le menu et qu'on voie l'état changer. */}
                <div className="d-flex align-items-center justify-content-between px-3 py-1">
                  <label
                    htmlFor="cursors-live-switch"
                    className="mb-0 me-3 d-flex align-items-center text-700 fs--1"
                    style={{
                      cursor: isTogglingCursors ? "default" : "pointer",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faArrowPointer}
                      className="me-2"
                      fixedWidth
                    />
                    Curseurs en direct
                  </label>
                  <Form.Check
                    type="switch"
                    id="cursors-live-switch"
                    role="switch"
                    aria-label="Activer ou désactiver les curseurs en direct"
                    checked={cursorsEnabled}
                    onChange={onToggleCursors}
                    disabled={isTogglingCursors}
                    className="mb-0"
                  />
                </div>
              </>
            )}
            <Dropdown.Divider />
            <Dropdown.Item
              as={"button"}
              className="text-danger"
              onClick={handleLogout}
            >
              Se deconnecter
            </Dropdown.Item>
          </div>
        </Dropdown.Menu>
      </Dropdown>
      <AvailabilityModal
        ref={AvailabilityModalRef}
        userId={user.id}
        title="Mes disponibilités"
      />
    </>
  );
};

export default ProfileDropdown;
